import { render } from "./SocialLoginButtons.vue?vue&type=template&id=479f0438&scoped=true"
import script from "./SocialLoginButtons.vue?vue&type=script&lang=js"
export * from "./SocialLoginButtons.vue?vue&type=script&lang=js"

import "./SocialLoginButtons.vue?vue&type=style&index=0&id=479f0438&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479f0438"]])

export default __exports__